import { render, staticRenderFns } from "./advice.vue?vue&type=template&id=33749a11&scoped=true"
import script from "./advice.vue?vue&type=script&lang=js"
export * from "./advice.vue?vue&type=script&lang=js"
import style0 from "./advice.vue?vue&type=style&index=0&id=33749a11&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33749a11",
  null
  
)

export default component.exports